import { render } from "./VaBeneFeatureListPage.vue?vue&type=template&id=2e7e9406&ts=true"
import script from "./VaBeneFeatureListPage.vue?vue&type=script&lang=ts"
export * from "./VaBeneFeatureListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__